import * as React from 'react';
import SVGIcon from '../SVGIcon';

interface Props {
  className?: string;
}

const ShareableLinkIcon: React.FC<Props> = ({ className }) => {
  return (
    <SVGIcon viewBox="0 0 20 20" width="20" height="20" fill="" className={className}>
      <path
        d="M3.51731 10.5892C1.79491 12.3116 1.89548 15.167 3.81999 16.7568C5.49819 18.1427 7.99733 17.8943 9.53646 16.3551L11.1776 14.714C11.5029 14.3887 11.5029 13.8607 11.1776 13.5355C10.8523 13.2102 10.3244 13.2102 9.99912 13.5355L8.33148 15.2031C7.37453 16.16 5.7995 16.301 4.79364 15.3941C3.72061 14.4284 3.68819 12.7753 4.69582 11.7677L6.46359 9.99991C6.78885 9.67465 6.78886 9.14669 6.46359 8.82142C6.13832 8.49615 5.61034 8.49615 5.28507 8.82142L3.51731 10.5892ZM8.82061 5.28589C8.49534 5.61116 8.49534 6.13913 8.82061 6.4644C9.14588 6.78967 9.67385 6.78967 9.99912 6.4644L11.6667 4.79676C12.6237 3.83981 14.1987 3.69885 15.2046 4.60571C16.2776 5.5715 16.31 7.22453 15.3024 8.23216L13.5346 9.99991C13.2094 10.3252 13.2094 10.8532 13.5346 11.1784C13.8599 11.5037 14.3879 11.5037 14.7131 11.1784L16.4809 9.41068C18.2033 7.68828 18.1027 4.83286 16.1782 3.24305C14.5 1.85712 12.0009 2.10557 10.4618 3.64471L8.82061 5.28589ZM7.05284 11.7677C6.72757 12.093 6.72757 12.6209 7.05284 12.9462C7.37811 13.2715 7.90608 13.2715 8.23135 12.9462L12.9454 8.23216C13.2706 7.90689 13.2706 7.37892 12.9454 7.05365C12.6201 6.72837 12.0921 6.72837 11.7669 7.05365L7.05284 11.7677Z"
        fill="currentColor"
      />
    </SVGIcon>
  );
};

export default ShareableLinkIcon;
